export default function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-interpolate/src/number.js
// module id = 43
// module chunks = 0 1 2 3 4